import React, {useEffect} from 'react';
import SectionLayout from '../../CommonComponents/Layout/sectionLayout';
import './style.css';
import {Col, Row} from 'antd';
import StandingCommiteeListing from '../../CommonComponents/StandingCommiteeListing';
import aboutImage from '../../../Assets/AboutUs.jpg';
import useLocalization from '../../../Localization';
import CustomizedTable from '../../CommonComponents/CommonTable';

const AboutUsComponent = ({
  pbssIntroHtml,
  ourMissionHtml,
  aboutUsImageUrl,
  leadershipMembers = [],
  operationsMembers = [],
  distinguishedAdvisorsMembers = [],
  programManagementMembers = [],
}) => {
  const {ApplicationString} = useLocalization();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }, []);

  const LeadershipHeading = () => <p>PBSS Leadership</p>;
  const OperationsHeading = () => <p>Operations Team</p>;
  const DistinguishedAdvisorsHeading = () => <p>Distinguished Advisors</p>;
  const ProgramManagementHeading = () => <p>Program Management</p>;

  return (
    <React.Fragment>
      <Row gutter={[0, 30]} className='pbssMainContainerRow'>
        {/* <Col span={24}>
          <SponsorOptionPageHeroText title={'About PBSS'} />
        </Col> */}
        <Col span={24}>
          <SectionLayout>
            <div className='about-us-container'>
              <label>{ApplicationString['userAboutUsComponent.heading']}</label>
              {pbssIntroHtml ? (
                <CustomizedTable TableData={pbssIntroHtml} />
              ) : (
                <p>{ApplicationString['userAboutUsComponent.paragraph']}</p>
              )}
            </div>
          </SectionLayout>
        </Col>
        <Col span={24}>
          <div className='commite-sub-container'>
            <SectionLayout>
              <div className='commite-sub-wapper'>
                <div className='commitee-left-section'>
                  <label>
                    {ApplicationString['userAboutUsComponent.ourMission']}
                  </label>
                  {ourMissionHtml ? (
                    <CustomizedTable TableData={ourMissionHtml} />
                  ) : (
                    <p>
                      {
                        ApplicationString[
                          'userAboutUsComponent.ourMissionParagraph'
                        ]
                      }
                    </p>
                  )}
                </div>
                {aboutUsImageUrl && aboutUsImageUrl.trim() !== '' ? (
                  <img 
                    src={aboutUsImageUrl} 
                    alt='About Us'
                    crossOrigin='anonymous'
                    onError={(e) => {
                      // If uploaded image fails, show default as fallback
                      e.target.src = aboutImage;
                    }}
                  />
                ) : (
                  <img 
                    src={aboutImage} 
                    alt='About Us' 
                  />
                )}
              </div>{' '}
            </SectionLayout>
          </div>
        </Col>
        <Col span={24}>
          <SectionLayout>
            <div className='responsiveness-about-us'>
              {leadershipMembers?.length > 0 && (
                <StandingCommiteeListing
                  data={leadershipMembers}
                  usedForLeadership={true}
                  heading={LeadershipHeading()}
                />
              )}
              {distinguishedAdvisorsMembers?.length > 0 && (
                <StandingCommiteeListing
                  data={distinguishedAdvisorsMembers}
                  heading={DistinguishedAdvisorsHeading()}
                />
              )}
              {operationsMembers?.length > 0 && (
                <StandingCommiteeListing
                  data={operationsMembers}
                  heading={OperationsHeading()}
                />
              )}
              {programManagementMembers?.length > 0 && (
                <StandingCommiteeListing
                  data={programManagementMembers}
                  heading={ProgramManagementHeading()}
                />
              )}
            </div>
          </SectionLayout>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default AboutUsComponent;
